import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  //スクロール禁止状態にする
  HtmlFix() {
    document.body.style.overflow = "hidden";
  }

  //スクロール禁止状態を解除する
  HtmlScroll() {
    document.body.style.overflow = "";
  }
}
